/**
 * Coerce any axios error / API response into a user-readable string.
 *
 * Defends against three common shapes:
 *   - string detail: { detail: "Some error" }
 *   - pydantic 422 array detail: { detail: [{type,loc,msg,input,url}, ...] }
 *   - object detail: { detail: { code, ... } }
 */
export function humanizeApiError(err, fallback = 'Something went wrong') {
  const detail = err?.response?.data?.detail;
  if (!detail) return err?.message || fallback;
  if (typeof detail === 'string') return detail;
  if (Array.isArray(detail)) {
    return detail.map((d) => d?.msg || JSON.stringify(d)).join('; ') || fallback;
  }
  try { return JSON.stringify(detail); } catch { return fallback; }
}
